import { useQuery } from '@tanstack/react-query';
import type { User } from '@/utils/types/User';
import { getUser } from './getUser';

export const useCurrentUser = ({ enabled = true }: { enabled?: boolean } = {}) => {
  const {
    data: user,
    isLoading,
    isError,
    error,
    status,
  } = useQuery({
    queryKey: ['user'],
    queryFn: () => getUser(),
    staleTime: Infinity,
    enabled,
  });

  return {
    user: user as User,
    isLoading,
    isError,
    error,
    status,
  };
};
